// Translation dictionary — keyed by short identifiers so call sites read
// as t("home.suggestedForYou") rather than repeating English strings that
// would need updating in three places every time copy changes.
//
// This starts with the highest-traffic surfaces (nav, login, common
// actions) rather than attempting the whole app in one pass — every other
// page still reads in English until it's translated the same way.
const translations = {
  en: {
    "nav.home": "Home",
    "nav.trending": "Trending",
    "nav.upload": "Upload a design",
    "nav.saved": "Saved",
    "nav.profile": "Profile",
    "nav.login": "Login",
    "nav.search": "Search",

    "common.follow": "Follow",
    "common.unfollow": "Unfollow",
    "common.following": "Following",
    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.loading": "Loading…",
    "common.loadingMore": "Loading more…",
    "common.logInToContinue": "Please log in to continue. Go to the login page now?",

    "home.followingTab": "Following",
    "home.exploreTab": "Explore",
    "home.noDesigns": "No designs yet.",
    "home.slowLoad": "Taking longer than usual…",
    "home.tryAgain": "Try again",

    "trending.title": "Trending",
    "trending.thisWeek": "This Week",
    "trending.thisMonth": "This Month",

    "saved.title": "Saved designs",
    "saved.empty": "Nothing saved yet — tap the bookmark icon on a design to save it here.",
    "saved.loginGate": "Please log in to see your saved designs.",

    "search.placeholder": "Search designs or people…",
    "search.recent": "Recent",
    "search.noRecent": "No recent searches yet.",

    "login.welcomeBack": "Welcome back",
    "login.signInSubtitle": "Sign in with your email.",
    "login.createAccount": "Create your account",
    "login.signIn": "Sign in",
    "login.signUp": "Create account",
    "login.usernameOrEmail": "Email",
    "login.password": "Password",
    "login.continue": "Continue →",

    "upload.heading": "Upload embroidery design",
    "upload.photos": "Photos",
    "upload.caption": "Caption",
    "upload.captionPlaceholder": "Write a caption… #phulkari #wedding #punjabi",
    "upload.uploadButton": "Upload",
    "upload.uploading": "Uploading…",
    "upload.uploaded": "Uploaded! Your design is live.",
    "upload.uploadAnother": "Upload another",
    "upload.goHome": "Go to home",
    "upload.subtitle": "Share your work with everyone here",
    "upload.cover": "Cover",
    "upload.optional": "Optional",
    "upload.needPhoto": "Add at least one photo to post",
    "upload.photosHint": "Tap to add photos",
    "upload.photosSub": "Up to 5 photos · you can crop each one",
    "upload.files": "Design files",
    "upload.filesHint": "Tap to add embroidery files",
    "upload.filesSub": "Up to 12 files (.dst, .pes, .jef …)",

    "profile.posts": "Posts",
    "profile.followers": "Followers",
    "profile.following": "Following",
    "profile.editProfile": "Edit profile",
    "profile.noPostsYet": "No posts yet — share your first design!",
    "profile.pinned": "Pinned",
    "profile.sortNewest": "Newest",
    "profile.sortOldest": "Oldest",
    "profile.sortLikes": "Most liked",
    "profile.sortPosts": "Sort posts",

    "comments.title": "Comments",
    "comments.placeholder": "Write a comment…",
    "comments.empty": "No comments yet — be the first to say something.",
    "comments.loginToComment": "Log in to leave a comment.",
    "comments.reply": "Reply",
  },

  pa: {
    "nav.home": "ਹੋਮ",
    "nav.trending": "ਟ੍ਰੈਂਡਿੰਗ",
    "nav.upload": "ਡਿਜ਼ਾਈਨ ਅੱਪਲੋਡ ਕਰੋ",
    "nav.saved": "ਸੇਵ ਕੀਤੇ",
    "nav.profile": "ਪ੍ਰੋਫਾਈਲ",
    "nav.login": "ਲੌਗਇਨ",
    "nav.search": "ਖੋਜ",

    "common.follow": "ਫਾਲੋ ਕਰੋ",
    "common.unfollow": "ਅਨਫਾਲੋ ਕਰੋ",
    "common.following": "ਫਾਲੋ ਕਰ ਰਹੇ ਹੋ",
    "common.cancel": "ਰੱਦ ਕਰੋ",
    "common.save": "ਸੇਵ ਕਰੋ",
    "common.delete": "ਮਿਟਾਓ",
    "common.edit": "ਸੋਧੋ",
    "common.loading": "ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ…",
    "common.loadingMore": "ਹੋਰ ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ…",
    "common.logInToContinue": "ਜਾਰੀ ਰੱਖਣ ਲਈ ਲੌਗਇਨ ਕਰੋ। ਹੁਣੇ ਲੌਗਇਨ ਪੇਜ 'ਤੇ ਜਾਣਾ ਹੈ?",

    "home.followingTab": "ਫਾਲੋ ਕੀਤੇ",
    "home.exploreTab": "ਐਕਸਪਲੋਰ",
    "home.noDesigns": "ਅਜੇ ਕੋਈ ਡਿਜ਼ਾਈਨ ਨਹੀਂ।",
    "home.slowLoad": "ਆਮ ਨਾਲੋਂ ਵੱਧ ਸਮਾਂ ਲੱਗ ਰਿਹਾ ਹੈ…",
    "home.tryAgain": "ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",

    "trending.title": "ਟ੍ਰੈਂਡਿੰਗ",
    "trending.thisWeek": "ਇਸ ਹਫ਼ਤੇ",
    "trending.thisMonth": "ਇਸ ਮਹੀਨੇ",

    "saved.title": "ਸੇਵ ਕੀਤੇ ਡਿਜ਼ਾਈਨ",
    "saved.empty": "ਹਾਲੇ ਕੁਝ ਸੇਵ ਨਹੀਂ ਕੀਤਾ — ਕਿਸੇ ਡਿਜ਼ਾਈਨ 'ਤੇ ਬੁੱਕਮਾਰਕ ਆਈਕਨ ਦਬਾ ਕੇ ਇੱਥੇ ਸੇਵ ਕਰੋ।",
    "saved.loginGate": "ਆਪਣੇ ਸੇਵ ਕੀਤੇ ਡਿਜ਼ਾਈਨ ਵੇਖਣ ਲਈ ਲੌਗਇਨ ਕਰੋ।",

    "search.placeholder": "ਡਿਜ਼ਾਈਨ ਜਾਂ ਲੋਕ ਖੋਜੋ…",
    "search.recent": "ਹਾਲੀਆ",
    "search.noRecent": "ਅਜੇ ਕੋਈ ਹਾਲੀਆ ਖੋਜ ਨਹੀਂ।",

    "login.welcomeBack": "ਵਾਪਸ ਸੁਆਗਤ ਹੈ",
    "login.signInSubtitle": "ਆਪਣੇ ਈਮੇਲ ਨਾਲ ਸਾਈਨ ਇਨ ਕਰੋ।",
    "login.createAccount": "ਆਪਣਾ ਖਾਤਾ ਬਣਾਓ",
    "login.signIn": "ਸਾਈਨ ਇਨ",
    "login.signUp": "ਖਾਤਾ ਬਣਾਓ",
    "login.usernameOrEmail": "ਈਮੇਲ",
    "login.password": "ਪਾਸਵਰਡ",
    "login.continue": "ਅੱਗੇ ਵਧੋ →",

    "upload.heading": "ਕਢਾਈ ਡਿਜ਼ਾਈਨ ਅੱਪਲੋਡ ਕਰੋ",
    "upload.photos": "ਫੋਟੋਆਂ",
    "upload.caption": "ਕੈਪਸ਼ਨ",
    "upload.captionPlaceholder": "ਕੈਪਸ਼ਨ ਲਿਖੋ… #phulkari #wedding #punjabi",
    "upload.uploadButton": "ਅੱਪਲੋਡ ਕਰੋ",
    "upload.uploading": "ਅੱਪਲੋਡ ਹੋ ਰਿਹਾ ਹੈ…",
    "upload.uploaded": "ਅੱਪਲੋਡ ਹੋ ਗਿਆ! ਤੁਹਾਡਾ ਡਿਜ਼ਾਈਨ ਲਾਈਵ ਹੈ।",
    "upload.uploadAnother": "ਹੋਰ ਅੱਪਲੋਡ ਕਰੋ",
    "upload.goHome": "ਹੋਮ 'ਤੇ ਜਾਓ",
    "upload.subtitle": "ਆਪਣਾ ਕੰਮ ਸਾਰਿਆਂ ਨਾਲ ਸਾਂਝਾ ਕਰੋ",
    "upload.cover": "ਕਵਰ",
    "upload.optional": "ਵਿਕਲਪਿਕ",
    "upload.needPhoto": "ਪੋਸਟ ਕਰਨ ਲਈ ਘੱਟੋ-ਘੱਟ ਇੱਕ ਫੋਟੋ ਪਾਓ",
    "upload.photosHint": "ਫੋਟੋਆਂ ਪਾਉਣ ਲਈ ਟੈਪ ਕਰੋ",
    "upload.photosSub": "5 ਫੋਟੋਆਂ ਤੱਕ · ਹਰ ਇੱਕ ਨੂੰ ਕ੍ਰੌਪ ਕਰ ਸਕਦੇ ਹੋ",
    "upload.files": "ਡਿਜ਼ਾਈਨ ਫਾਈਲਾਂ",
    "upload.filesHint": "ਕਢਾਈ ਫਾਈਲਾਂ ਪਾਉਣ ਲਈ ਟੈਪ ਕਰੋ",
    "upload.filesSub": "12 ਫਾਈਲਾਂ ਤੱਕ (.dst, .pes, .jef …)",

    "profile.posts": "ਪੋਸਟਾਂ",
    "profile.followers": "ਫਾਲੋਅਰ",
    "profile.following": "ਫਾਲੋ ਕੀਤੇ",
    "profile.editProfile": "ਪ੍ਰੋਫਾਈਲ ਸੋਧੋ",
    "profile.noPostsYet": "ਅਜੇ ਕੋਈ ਪੋਸਟ ਨਹੀਂ — ਆਪਣਾ ਪਹਿਲਾ ਡਿਜ਼ਾਈਨ ਸ਼ੇਅਰ ਕਰੋ!",
    "profile.pinned": "ਪਿੰਨ ਕੀਤਾ",
    "profile.sortNewest": "ਨਵੇਂ",
    "profile.sortOldest": "ਪੁਰਾਣੇ",
    "profile.sortLikes": "ਸਭ ਤੋਂ ਵੱਧ ਪਸੰਦ",
    "profile.sortPosts": "ਪੋਸਟਾਂ ਨੂੰ ਲੜੀਬੱਧ ਕਰੋ",

    "comments.title": "ਟਿੱਪਣੀਆਂ",
    "comments.placeholder": "ਟਿੱਪਣੀ ਲਿਖੋ…",
    "comments.empty": "ਹਾਲੇ ਕੋਈ ਟਿੱਪਣੀ ਨਹੀਂ — ਪਹਿਲੇ ਬਣੋ।",
    "comments.loginToComment": "ਟਿੱਪਣੀ ਕਰਨ ਲਈ ਲੌਗਇਨ ਕਰੋ।",
    "comments.reply": "ਜਵਾਬ",
  },

  hi: {
    "nav.home": "होम",
    "nav.trending": "ट्रेंडिंग",
    "nav.upload": "डिज़ाइन अपलोड करें",
    "nav.saved": "सेव किए हुए",
    "nav.profile": "प्रोफ़ाइल",
    "nav.login": "लॉगिन",
    "nav.search": "खोजें",

    "common.follow": "फॉलो करें",
    "common.unfollow": "अनफॉलो करें",
    "common.following": "फॉलो कर रहे हैं",
    "common.cancel": "रद्द करें",
    "common.save": "सेव करें",
    "common.delete": "मिटाएं",
    "common.edit": "संपादित करें",
    "common.loading": "लोड हो रहा है…",
    "common.loadingMore": "और लोड हो रहा है…",
    "common.logInToContinue": "जारी रखने के लिए लॉगिन करें। अभी लॉगिन पेज पर जाएं?",

    "home.followingTab": "फॉलो किए",
    "home.exploreTab": "एक्सप्लोर",
    "home.noDesigns": "अभी कोई डिज़ाइन नहीं है।",
    "home.slowLoad": "सामान्य से अधिक समय लग रहा है…",
    "home.tryAgain": "फिर से कोशिश करें",

    "trending.title": "ट्रेंडिंग",
    "trending.thisWeek": "इस हफ़्ते",
    "trending.thisMonth": "इस महीने",

    "saved.title": "सेव किए गए डिज़ाइन",
    "saved.empty": "अभी कुछ भी सेव नहीं किया — किसी डिज़ाइन पर बुकमार्क आइकन दबाकर यहां सेव करें।",
    "saved.loginGate": "अपने सेव किए गए डिज़ाइन देखने के लिए लॉगिन करें।",

    "search.placeholder": "डिज़ाइन या लोग खोजें…",
    "search.recent": "हाल की खोजें",
    "search.noRecent": "अभी कोई हाल की खोज नहीं।",

    "login.welcomeBack": "वापसी पर स्वागत है",
    "login.signInSubtitle": "अपने ईमेल से साइन इन करें।",
    "login.createAccount": "अपना खाता बनाएं",
    "login.signIn": "साइन इन",
    "login.signUp": "खाता बनाएं",
    "login.usernameOrEmail": "ईमेल",
    "login.password": "पासवर्ड",
    "login.continue": "आगे बढ़ें →",

    "upload.heading": "कढ़ाई डिज़ाइन अपलोड करें",
    "upload.photos": "फ़ोटो",
    "upload.caption": "कैप्शन",
    "upload.captionPlaceholder": "कैप्शन लिखें… #phulkari #wedding #punjabi",
    "upload.uploadButton": "अपलोड करें",
    "upload.uploading": "अपलोड हो रहा है…",
    "upload.uploaded": "अपलोड हो गया! आपका डिज़ाइन लाइव है।",
    "upload.uploadAnother": "और अपलोड करें",
    "upload.goHome": "होम पर जाएं",
    "upload.subtitle": "अपना काम सबके साथ साझा करें",
    "upload.cover": "कवर",
    "upload.optional": "वैकल्पिक",
    "upload.needPhoto": "पोस्ट करने के लिए कम से कम एक फ़ोटो जोड़ें",
    "upload.photosHint": "फ़ोटो जोड़ने के लिए टैप करें",
    "upload.photosSub": "5 फ़ोटो तक · हर एक को क्रॉप कर सकते हैं",
    "upload.files": "डिज़ाइन फ़ाइलें",
    "upload.filesHint": "कढ़ाई फ़ाइलें जोड़ने के लिए टैप करें",
    "upload.filesSub": "12 फ़ाइलों तक (.dst, .pes, .jef …)",

    "profile.posts": "पोस्ट",
    "profile.followers": "फॉलोअर",
    "profile.following": "फॉलो किए गए",
    "profile.editProfile": "प्रोफ़ाइल संपादित करें",
    "profile.noPostsYet": "अभी कोई पोस्ट नहीं — अपना पहला डिज़ाइन शेयर करें!",
    "profile.pinned": "पिन किया गया",
    "profile.sortNewest": "नए",
    "profile.sortOldest": "पुराने",
    "profile.sortLikes": "सबसे ज़्यादा पसंद",
    "profile.sortPosts": "पोस्ट क्रमबद्ध करें",

    "comments.title": "टिप्पणियां",
    "comments.placeholder": "टिप्पणी लिखें…",
    "comments.empty": "अभी कोई टिप्पणी नहीं — पहले बनें।",
    "comments.loginToComment": "टिप्पणी करने के लिए लॉगिन करें।",
    "comments.reply": "जवाब",
  },
};

export default translations;
